import { useEffect } from 'react'
import { useRouter } from 'next/router'

const ChangePasswordRedirect = () => {
  const router = useRouter()

  useEffect(() => {
    router.replace('/settings')
  }, [router])

  return null
}

export default ChangePasswordRedirect
